import script from "./NewsfeedCreatorPost.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsfeedCreatorPost.vue?vue&type=script&setup=true&lang=js"

import "./NewsfeedCreatorPost.vue?vue&type=style&index=0&id=384efad2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-384efad2"]])

export default __exports__